import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { ProductKeyTypes } from '@/libraries/wpl/foundations/src/data-event-props';

import { TitleCard } from '../components/card';
import { useWhyAtlassianData } from '../why-atlassian-subnav';

import { MobileNavTitle } from './mobile-nav-card';

const mobileWhyAtlassianGridCss = css({
	display: 'flex',
	flexDirection: 'column',
	gap: '0',
	padding: '0',
});

export const MobileNavWhyAtlassian = ({
	productKey = 'home',
}: {
	productKey?: ProductKeyTypes;
}) => {
	const intl = useIntl();

	const whyAtlassianData = useWhyAtlassianData();

	return (
		<div>
			<MobileNavTitle
				title={intl.formatMessage({
					id: 'globalnav.v2.whyatlassian.title',
					defaultMessage: 'Why Atlassian',
				})}
			/>
			<div css={mobileWhyAtlassianGridCss}>
				{whyAtlassianData.map(({ title, ...rest }) => (
					<TitleCard key={title} title={title} {...rest} productKey={productKey} />
				))}
			</div>
		</div>
	);
};
